import {
  TableHead as MUITableHead,
  TableRow as MUITableRow,
  TableSortLabel as MUITableSortLabel,
} from '@mui/material';

import { Checkbox } from '../../Shared';
import { TableHeadCell } from '../TableHeadCell';

export const TableHead = ({
  isCheckboxVisible = true,
  cells,
  isSomeRowsSelected,
  isAllRowsSelected,
  onSelectAllRows,
  order,
  orderBy,
  onRequestSort,
}) => {
  return (
    <MUITableHead>
      <MUITableRow>
        {isCheckboxVisible && (
          <TableHeadCell width="48px">
            <Checkbox
              indeterminate={isSomeRowsSelected}
              checked={isAllRowsSelected}
              onChange={onSelectAllRows}
              size="xl"
            />
          </TableHeadCell>
        )}
        {cells.map(cell => (
          <TableHeadCell
            key={cell.id}
            align={cell.align}
            width={cell.width}
            sortDirection={orderBy === cell.id ? order : false}
          >
            {cell.sortable ? (
              <MUITableSortLabel
                active={orderBy === cell.id}
                direction={orderBy === cell.id ? order : 'asc'}
                onClick={() => {
                  onRequestSort(cell.id);
                }}
              >
                {cell.label}
              </MUITableSortLabel>
            ) : (
              cell.label
            )}
          </TableHeadCell>
        ))}
      </MUITableRow>
    </MUITableHead>
  );
};
